// Module
var code = "<div class=\"theme-content-synthese theme-content-synthese--importance-medium\"> <h2 compile=\"::ctrl.sItem.title\"></h2> <ws-content-block s-item=\"::item\" s-color=\"::ctrl.sColor\" ng-repeat=\"item in ::ctrl.sItem.children\" ng-if=\"::ctrl.sItem.children\"></ws-content-block> </div> ";
// Exports
module.exports = code;